import * as React from 'react';
import {
  SectionList, IItem, ISection, IndexPath
} from '@wmfe/mach-pro-components-react';
import './index.css';
import { animationTemp } from '../../utils';

interface IState {
  showPicker: boolean;
  selectedIndex: number;
  selectedData: any;
}

interface Props {
  title: string;
  btnText?: string;
  listData: Array<any>;
  sectionKey?: string;
  defaultSelectIndex?: number;
  defaultSelectedLocal?: any;
  onClickBtn?: (result: any) => void;
  onClickMask?: () => void;
}

export default class DataPicker extends React.Component<Props, IState> {
  constructor(props: Props) {
    super(props);
    let selectedIndex = props.defaultSelectIndex || 0;
    let selectedData = props.listData[0];
    if (props.listData.length > 0 && !!props.defaultSelectedLocal) {
      props.listData.forEach((element, index) => {
        if (!!element.locale && element.locale === props.defaultSelectedLocal) {
          selectedIndex = index;
          selectedData = element;
        }
      });
    }

    this.state = {
      showPicker: true,
      selectedIndex,
      selectedData,
    };
  }
  maskView?: any = null; // 蒙层: 做透明度渐变动画
  containerView?: any = null; // 容器: 做向上位移动画

  onClickBtn = () => {
    this.handleDialogHidden(() => {
      this.props.onClickBtn?.(this.state.selectedData);
    });
  }

  onClickListItem = (item: IItem) => {
    const { indexPath, data } = item;
    this.setState({
      selectedIndex: indexPath.section,
      selectedData: data
    });
  }

  renderItem = (item: IItem) => {
    const { selectedIndex } = this.state;
    const { data, indexPath } = item;
    const selected = selectedIndex === indexPath.section;
    return (
      <view
        className={selected ? 'cell-container-selected' : 'cell-container'}
        onClick={() => this.onClickListItem(item)}
      >
        <image
          className="cell-icon"
          src={selected ? 'assets://address/checked.png' : 'assets://address/check.png'}
        />
        <text
          className="cell-title"
          content={data.localizedDisplayName || ''}
        />
      </view>
    );
  }

  handleMaskViewShow = () => {
    console.log('handleMaskViewShow');
    if (!this.maskView) {
      return;
    }
    const keyFrames = {
      from: { opacity: 0 },
      to: { opacity: 1 },
    };
    const maskShow = animationTemp(keyFrames);
    this.maskView?.setAnimation(maskShow, () => {});
  }

  handleContainerViewShow = () => {
    if (!this.containerView) {
      return;
    }

    const conatinerFrame = this.containerView.measure();
    const contanierHegit = conatinerFrame?.height + Mach.env.softMenuBarHeight;
    const fromValue = contanierHegit;
    const toValue = 0;
    const keyFrames = {
      from: { transform: `translateY(${fromValue})` },
      to: { transform: `translateY(${toValue})` }
    };
    const containerShow = animationTemp(keyFrames);
    this.containerView.setAnimation(containerShow, (callback) => {});
  }

  handleDialogHidden = (finished?: Function) => {
    if (!this.containerView || !this.maskView) {
      finished?.();
      return;
    }
    const frame = this.containerView.measure();
    const contanierHegit = frame.height + Mach.env.softMenuBarHeight;
    const keyFrames = {
      from: { transform: 'translateY(0)' },
      to: { transform: `translateY(${contanierHegit})` },
    };
    const containerHidden = animationTemp(keyFrames);
    const maskFrames = {
      from: { opacity: 1 },
      to: { opacity: 0 },
    };
    const maskHidden = animationTemp(maskFrames);
    this.containerView.setAnimation(containerHidden, () => {});
    this.maskView?.setAnimation(maskHidden, (callback) => {
      if (callback.state === 'end') {
        finished?.();
      }
    });
  }

  render() {
    const { selectedIndex } = this.state;
    const { listData } = this.props;
    const safeBottomHeight = Mach.env.safeAreaInsets.bottom || 16;

    return (
      <modal onRequestCloseDialog={() => this.props.onClickMask?.()}>
        <view
          className="dialog-mask"
          onClick={() => {
            this.handleDialogHidden(() => {
              this.props.onClickMask?.();
            });
          }}
          ref={(ref: any) => { this.maskView = ref; }}
          onLayout={() => {
            // layout完成展示modal
            this.handleMaskViewShow();
          }}
        >
          <view
            className="dialog-container"
            onClick={() => {
              //do noting 防止点击内容区域弹窗消失
            }}
            ref={(ref: any) => { this.containerView = ref; }}
            onLayout={() => {
              // layout完成展示modal
              this.handleContainerViewShow();
            }}
          >
            <text className="dialog-title" content={this.props.title} />
            <view
              className="list-container"
              style={{ height: `${listData.length * 52 + 20}dp` }}
            >
              <SectionList
                sectionKey={(section: any) => section.key || section.locale}
                sectionValue={(section: any) => [section]}
                itemKey={(item: any) => item?.key || 'NULL'}
                sections={listData}
                renderItem={this.renderItem}
                bounces={false}
                loading={false}
                extraData={{ selectedIndex }}
              />
            </view>
            <view className="line" />
            <view className="dialog-button-container" style={{ height: (16 + 50 + safeBottomHeight) }}>
              {this.props.btnText
                                && (
                                  <text
                                    className="dialog-button"
                                    content={this.props.btnText}
                                    onClick={() => this.onClickBtn()}
                                  />
                                )}
            </view>
          </view>
        </view>
      </modal>
    );
  }
}
